// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1-kgE","title":"ClientReferral_title__1caVG","itemText":"ClientReferral_itemText__GUiU3"};